import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
});

export async function getTickets() {
  const { data } = await api.get("/tickets");
  return data;
}

export async function createRegistration(payload) {
  const { data } = await api.post("/registrations", payload);
  return data;
}

// 2.6: client Idempotency-Key nagłówkiem; payment Turnstile token NIE trafia tutaj (tylko rejestracja).
export async function createCheckout(payload, { idempotencyKey } = {}) {
  const headers = {};
  if (idempotencyKey) headers["Idempotency-Key"] = idempotencyKey;
  const { data } = await api.post("/payments/checkout", payload, { headers });
  return data;
}

export async function getPaymentStatus(sessionId) {
  const { data } = await api.get(`/payments/status/${encodeURIComponent(sessionId)}`);
  return data;
}

